import type { BatchRefreshPreview } from '../../services/api';

export const hasRelatedBatchRefreshChanges = (
    preview: BatchRefreshPreview,
): boolean => Boolean(
    preview.relatedChanges?.constraints
    || preview.relatedChanges?.shareGroups
    || preview.relatedChanges?.resourceRules,
);

// 刷新是完整模板替换，而不是“应用有差异的行”。只要批次状态允许，
// 即使预览为零差异，也应允许执行一次权威重建来清理历史残留。
export const canReplaceBatchTemplate = (
    preview: BatchRefreshPreview,
): boolean => preview.canRefresh;
